module.exports = __webpack_public_path__ + "img/orange_100.2f070a40.png";